/*
 * STATUS / AGENT NOTES (2026-08-07)
 * Client-side search and category filtering for the how-to hub. No observers or page-wide listeners.
 * Agent START: Codex how-to hub interactions
 */
(function () {
  'use strict';

  function initHowToHub(root) {
    if (!root || root.dataset.howtoReady === 'true') return;
    root.dataset.howtoReady = 'true';

    var input = root.querySelector('[data-howto-search]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-howto-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-guide-card]'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-howto-section]'));
    var empty = root.querySelector('[data-howto-empty]');
    var results = root.querySelector('[data-howto-results]');
    var activeCategory = 'all';

    function normalize(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function updateResults(count, query) {
      if (!results) return;
      if (query) {
        results.textContent = count === 1 ? '1 matching guide' : count + ' matching guides';
      } else if (activeCategory === 'all') {
        results.textContent = 'Showing all ' + count + ' guides';
      } else {
        results.textContent = count === 1 ? 'Showing 1 guide' : 'Showing ' + count + ' guides';
      }
    }

    function applyFilters() {
      var query = normalize(input && input.value);
      var visibleCount = 0;

      cards.forEach(function (card) {
        var categoryMatch = activeCategory === 'all' || card.dataset.category === activeCategory;
        var searchableText = normalize(card.textContent + ' ' + (card.dataset.terms || ''));
        var searchMatch = !query || searchableText.indexOf(query) !== -1;
        var isVisible = categoryMatch && searchMatch;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      sections.forEach(function (section) {
        var hasVisibleCard = Array.prototype.some.call(section.querySelectorAll('[data-guide-card]'), function (card) {
          return !card.hidden;
        });
        section.hidden = !hasVisibleCard;
      });

      if (empty) empty.hidden = visibleCount !== 0;
      updateResults(visibleCount, query);
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.dataset.howtoFilter || 'all';
        filters.forEach(function (filter) {
          filter.setAttribute('aria-pressed', String(filter === button));
        });
        applyFilters();
      });
    });

    if (input) input.addEventListener('input', applyFilters);
    applyFilters();
  }

  function init() {
    document.querySelectorAll('[data-howto-finder]').forEach(initHowToHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHowToHub(event.target.querySelector('[data-howto-finder]'));
  });
})();
/* Agent END: Codex how-to hub interactions */
